// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610160435/js/" + chunkId + "." + {"44":"693d670f","225":"0d5e44be","481":"4d6a97c4","486":"844a4ce1","770":"d70b4df8"}[chunkId] + ".0.5235803478601391.chunk.js";
};